export const PRICE_LABEL = { fuel: "Fuel Surcharge", visa: "Visa", ppn: "PPN", tipping: "Tipping", insurance: "Asuransi", other: "Lain-lain" };

export const defaultPrice = () => ({
  basic: null, discounted: null, ppn_auto: true, total: null, total_auto: true,
  items: ["fuel", "visa", "ppn", "tipping", "insurance"].map((type) => ({ type, label: PRICE_LABEL[type], amount: null })),
});

// mirrors backend seat_io.compute_price: PPN = 1.1% of base + components above it
export function computePrice(p) {
  let running = p.discounted ?? p.basic ?? 0;
  const items = p.items.map((it) => {
    const amount = it.type === "ppn" && p.ppn_auto ? Math.floor((running * 11 + 500) / 1000) : it.amount;
    running += amount || 0;
    return { ...it, amount };
  });
  return { ...p, items, total: p.total_auto ? running : p.total };
}

export const hasPrice = (p) => !!p && (p.basic != null || p.discounted != null || p.total != null);
export const fmtRp = (n) => (n == null ? "-" : `Rp ${Number(n).toLocaleString("id-ID")}`);
export const parseMoney = (s) => { const d = String(s).replace(/\D/g, ""); return d ? Number(d) : null; };
